import fetchAccessCode from '../services/fetchAccessCode';

export default function usePublishAccessCode() {
  const publishAccessCode = async (email: string) => {
    await fetchAccessCode(email);
  };

  return publishAccessCode;
}
